<div class="component-container">
  <div
    class="row w-full
          flex flex-col justify-center
          md:flex-row md:space-x-[1rem]"
  >
    <app-search-on-select
      (checkForErrors)="checkForErrors($event)"
      (onNextPage)="clientsOnNextPage()"
      [enableClearSelection]="false"
      [enableMultiple]="false"
      [error]="errorMessages['clientId']"
      [hasNext]="clientOptions.hasNext"
      [loading]="clientOptions.loading"
      [options]="clientOptions.list"
      [parentFormGroup]="form"
      class="input md:w-[25%] md:min-w-[25%] lg:w-[15%] lg:min-w-[15%] w-full flex-grow"
      controlName="clientId"
      filterControlName="searchClient"
      label="Organization"
      optionsPanelClassName="clients-dropdown"
      placeholder="Select all that apply"
      type="small"
    ></app-search-on-select>
    <app-search-on-select
      (checkForErrors)="checkForErrors($event)"
      (onNextPage)="groupOnNextPage()"
      [enableClearSelection]="false"
      [enableMultiple]="false"
      [error]="errorMessages['groupId']"
      [hasNext]="groupOptions.hasNext"
      [loading]="groupOptions.loading"
      [options]="groupOptions.list"
      [parentFormGroup]="form"
      class="input md:w-[25%] md:min-w-[25%] lg:w-[15%] lg:min-w-[15%] w-full flex-grow"
      controlName="groupId"
      filterControlName="searchGroup"
      label="Group"
      optionsPanelClassName="clients-dropdown"
      placeholder="Select all that apply"
      type="small"
    ></app-search-on-select>
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [enableClearSelection]="true"
      [enableMultiple]="true"
      [error]="errorMessages['role']"
      [options]="roleFilterList"
      [parentFormGroup]="form"
      class="input md:w-[25%] md:min-w-[25%] lg:w-[15%] lg:min-w-[15%] w-full flex-grow"
      controlName="role"
      label="Role"
      placeholder="Select all that apply"
      type="small"
    />

  </div>
  <div
    class="row w-full
          flex flex-col justify-center
          md:flex-row md:space-x-[1rem] items-center"
  >
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['session']"
      [options]="sessionFilterList"
      [parentFormGroup]="form"
      class="input md:w-[25%] md:min-w-[25%] lg:w-[15%] lg:min-w-[15%] w-full flex-grow"
      controlName="session"
      label="Sessions"
      placeholder="Select all that apply"
      type="small"
    />
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [enableClearSelection]="true"
      [enableMultiple]="true"
      [error]="errorMessages['status']"
      [options]="statusFilterList"
      [parentFormGroup]="form"
      class="input md:w-[25%] md:min-w-[25%] lg:w-[15%] lg:min-w-[15%] w-full flex-grow"
      controlName="status"
      label="Status"
      placeholder="Select all that apply"
      type="small"
    />
    <div class="vertical hidden md:block"></div>

    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      (handleSuffixClick)="apply()"
      [error]="errorMessages['searchText']"
      [minLength]="0"
      [parentFormGroup]="form"
      class="input w-full md:w-[25%] md:min-w-[25%] lg:w-[15%] lg:min-w-[15%] search-input flex-grow"
      controlName="searchText"
      label="Search"
      placeholder="Search by name"
      suffixIcon="search"
      type="small"
    ></app-text-input>

    <div class="vertical hidden md:block"></div>

    <app-primary-button
      (handleClick)="apply()"
      [isDisabled]="!form.dirty"
      class="btn lg:w-[10%] md:w-[10%] w-full flex-grow"
      type="small"
    >
      Apply
    </app-primary-button>
  </div>
  <div
    class="row w-full mb-[2rem] flex flex-row justify-evenly items-center toggle-panel"
  >
    <div
      (click)="select(eachConfig.id)"
      *ngFor="let eachConfig of config; let i = index"
      [class.selected]="eachConfig['isSelected']"
      class="toggle-panel-item xs:text-[1.4rem] sm:text-[1.4rem] md:text-[1.6rem]"
    >

      {{ eachConfig.label }}
    </div>
  </div>
</div>
